import React from 'react';
import './App.css';
import { useNavigate } from "react-router-dom"
import routes from './routes';
import { Security } from '@okta/okta-react';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { oktaConfig } from './Common/Okta/Okta.Config';

const oktaAuth = new OktaAuth(oktaConfig);
export default function App() {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: any, originalUri: any) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} key={"dwd"}>
    {routes}
  </Security>
}

